import React from "react";
import PromptTextDisplay from "./PromptTextDisplay";
import VersionInfo from "./VersionInfo";
import CommentsSection from "../../../CommentsSection"; // relative path back to components root
import RightSidebar from "./RightSidebar";
import SystemPromptDisplay from './SystemPromptDisplay';
import { onAuthRequired } from "@/utils/auth"; // keep for type reference; actual function may be passed differently if needed

import { Model } from '@/hooks/useModels';

interface DiscoverTabProps {
  displayContent: {
    title: string;
    description: string;
    full_text: string;
    systemprompt: string;
  };
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  latestVersion: any; // Existing codebase likely has a Version type; keeping any to avoid circular imports here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  prompt: any;
  models: Model[];
  promptId: string;
  isLoggedIn: boolean;
  currentUserId?: string;
  onAuthRequired: typeof onAuthRequired;
  onCopyText: (text: string, type: string) => void;
  totalCopies: number;
  isOwner: boolean;
  isPublic: boolean;
  onToggleVisibility: () => Promise<void> | void;
  showComments: boolean;
}

const DiscoverTab: React.FC<DiscoverTabProps> = ({
  displayContent,
  latestVersion,
  prompt,
  models,
  promptId,
  isLoggedIn,
  currentUserId,
  onAuthRequired,
  onCopyText,
  totalCopies,
  isOwner,
  isPublic,
  onToggleVisibility,
  showComments,
}) => {
  return (
    <>
      <div className="max-w-[50rem] lg:flex-1 p-3 sm:p-4 md:p-6 space-y-4 sm:space-y-6 bg-white dark:bg-slate-800 transition-colors duration-300">
        {displayContent.systemprompt && <SystemPromptDisplay systemPrompt={displayContent.systemprompt} onCopy={onCopyText} />}
        <PromptTextDisplay
          promptText={displayContent.full_text}
          onCopy={onCopyText}
          latestVersion={latestVersion}
        />
        {latestVersion && <VersionInfo latestVersion={latestVersion} />}
        {showComments && (
          <CommentsSection
            promptId={Number(promptId)}
            isLoggedIn={isLoggedIn}
            onAuthRequired={onAuthRequired}
            currentUserId={currentUserId!}
          />
        )}
      </div>
      <RightSidebar
        prompt={prompt}
        models={models}
        totalCopies={totalCopies}
        isOwner={isOwner}
        isPublic={isPublic}
        onToggleVisibility={onToggleVisibility}
        onCopyText={onCopyText}
      />
    </>
  );
};

export default DiscoverTab;
